import { render, staticRenderFns } from "./Earlywarn.vue?vue&type=template&id=6486380e&scoped=true"
import script from "./Earlywarn.vue?vue&type=script&lang=js"
export * from "./Earlywarn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6486380e",
  null
  
)

export default component.exports